export const originsSelector=state=>state.homeReducer.origins;

export const originSupportedDestinationsSelector = state =>state.homeReducer.originSupportedDestinations;

export const selectedScheduleSeatsSelector = state =>state.homeReducer.selectedScheduleSeats;

export const selectedScheduleSelector = state =>state.homeReducer.selectedSchedule;

export const bookedTicketObjectSelector = state =>state.homeReducer.bookedTicketObject;
